import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

const MinecraftContext = createContext();

// Only poll on pages that actually display server status
function shouldPoll(pathname) {
  // Only poll on public pages that display the player count (Navbar, HowToJoinPage)
  if (pathname.startsWith('/event/')) return false;
  if (pathname.startsWith('/panel')) return false;
  if (pathname === '/xbox-callback') return false;
  return true;
}

export function MinecraftProvider({ children }) {
  const [serverStatus, setServerStatus] = useState({
    online: false,
    players: { online: 0, max: 0 }
  });
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const active = shouldPoll(location.pathname);

  const fetchServerStatus = useCallback(async () => {
    try {
      const response = await fetch('/api/minecraft');
      if (response.ok) {
        const data = await response.json();
        setServerStatus(data);
      }
    } catch (err) {
      console.error('Error fetching server status:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!active) return;

    fetchServerStatus();
    const interval = setInterval(fetchServerStatus, 300000);
    return () => clearInterval(interval);
  }, [active, fetchServerStatus]);

  return (
    <MinecraftContext.Provider value={{ serverStatus, loading }}>
      {children}
    </MinecraftContext.Provider>
  );
}

export function useMinecraftStatus() {
  const context = useContext(MinecraftContext);
  if (!context) {
    throw new Error('useMinecraftStatus must be used within a MinecraftProvider');
  }
  return context;
}
